<form nz-form style="padding-top:12px;padding-right:12px" [formGroup]="validateForm" autocomplete="off">
  <div nz-row [nzGutter]="['0','0']">
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="userName" nzRequired>Tên đăng nhập</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <input nz-input formControlName="userName" name="userName" type="text" placeholder="Nhập tên đăng nhập" readonly>
      </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="fullName" nzRequired>Họ tên</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <input nz-input formControlName="fullName" name="fullName" type="text" placeholder="Nhập họ tên">
      </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="address">Địa chỉ</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input formControlName="address" name="address" type="text" placeholder="Nhập địa chỉ">
      </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="email">Email</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input formControlName="email" name="email" type="text" placeholder="Nhập email">
      </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="phoneNumber">Số điện thoại</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input formControlName="phoneNumber" name="phoneNumber" type="text" placeholder="Nhập số điện thoại">
      </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="tenCS" nzRequired>Nhóm quyền</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <asc-autocomplete label="Nhóm quyền" [ascModel]="groupControl" [readonly]="true"
            (ascModelChange)="changeGroup($event)" placeholder="Chọn nhóm quyền..." [disabled]="true"
            [getListAC]="getGroupACFn">
          </asc-autocomplete>
      </nz-form-control>
      </nz-form-item >
    </div>
  </div>
  <div class="drawer-footer">
    <popup-btn-footer 
      [isDisableUpdate]="false"
      [isUpdateAndClose]="true" 
      (updateAndClose)="UpdateClose()"
      (close)="close()"
      >
    </popup-btn-footer>
  </div>
</form>
